import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostPollLoading, EGetPostPollActionType } from './types';

export const getPostPollLoading: () => TGetPostPollLoading = actionGenerator<EGetPostPollActionType.Loading>(
  EGetPostPollActionType.Loading,
);
